"use client";
import { IScrollableTabsCategory } from "@/api/AppApi/services/home/interfaces/IScrollableTabs";
import { PropsWithChildren } from "react";
import { Element } from "react-scroll";

interface Props {
  data: IScrollableTabsCategory;
}

const TabsContainer: React.FC<PropsWithChildren<Props>> = ({
  children,
  data,
}) => {
  const TsElement = Element as any;
  return (
    <TsElement name={data.name} key={data.name}>
      {children}
    </TsElement>
  );
};

export default TabsContainer;
